export default class NullSearch implements Searchable {
	name: string;

	constructor() {
		this.name = 'NullSearch';
	}

	// eslint-disable-next-line no-unused-vars
	search(query: SearchablesQuery, startIndex: StartIndexType, limit: number): Promise<SearchResult> {
		return new Promise((resolve) => {
			resolve({
				resultItems: [],
				serverResult: {
					url: 'null',
					message: '',
					requestId: '0',
					status: 200,
					duration: 0,
				},
				totalResults: 0,
				duration: 0,
			});
		});
	}
}
